module.exports = __webpack_public_path__ + "static/img/whool.f349310.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/furnitures/whool.png
// module id = S2NC
// module chunks = 0